"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractUpdateVariantCommand = void 0;
const AbstractVariantCommand_1 = require("../AbstractVariantCommand");
class AbstractUpdateVariantCommand extends AbstractVariantCommand_1.AbstractVariantCommand {
    constructor(api, appId, variantId, variantType) {
        super(api, appId);
        this.def = {};
        this.withName = (name) => {
            this.def.name = name;
            return this;
        };
        this.withDescription = (description) => {
            this.def.description = description;
            return this;
        };
        this.withDeveloper = (developer) => {
            this.def.developer = developer;
            return this;
        };
        this.withVariantDefinition = (def) => {
            this.def = {
                ...this.def,
                ...def,
            };
            return this;
        };
        this.exec = async () => {
            await this.api.put(`/applications/${this.appId}/${this.type}/${this.variantId}`, this.def);
        };
        this.variantId = variantId;
        this.type = variantType;
    }
}
exports.AbstractUpdateVariantCommand = AbstractUpdateVariantCommand;
//# sourceMappingURL=AbstractUpdateVariantCommand.js.map